export default __webpack_public_path__ + "static/create-workflow-326b937d228b92729be0529b0335122d.png";